import React from 'react';

import { usePatchFilter, useFilter, useData, usePerformExport } from './context';
import {
  ActivityHeaderInfoCol,
  ExportButtonStyled,
  ActivityHeaderCol,
  ActivityDuration,
  ActivityHeader,
  ActivityTitle,
  ContentBoard
} from '../styledComponents';

export default function () {
  const { summary, vehiclesStat } = useData();
  const performExport = usePerformExport();
  const patchFilter = usePatchFilter();
  const filter = useFilter();

  return (
    <>
      <ContentBoard>
        <ActivityHeader>
          <ActivityHeaderCol>
            <ActivityTitle>Dealer verification statistics</ActivityTitle>
            <ActivityDuration>
              <div
                className={filter?.duration === 1 ? 'active' : ''}
                onClick={() => patchFilter({ duration: 1 })}
              >
                Today
              </div>
              <div
                className={filter?.duration === 7 ? 'active middle' : 'middle'}
                onClick={() => patchFilter({ duration: 7 })}
              >
                7 days
              </div>
              <div
                className={filter?.duration === 30 ? 'active' : ''}
                onClick={() => patchFilter({ duration: 30 })}
              >
                30 days
              </div>
            </ActivityDuration>
          </ActivityHeaderCol>
          <ActivityHeaderInfoCol>
            <div>
              <div>
                <span>Total units submitted:</span>
                <span>
                  {summary?.totalCount ? summary.totalCount.toLocaleString('en-US') : '-'}
                </span>
              </div>
              <div>
                <span>Total units verified:</span>
                <span>
                  {summary?.successCount ? summary.successCount.toLocaleString('en-US') : '-'}
                </span>
              </div>
              <div>
                <span>General pass rate:</span>
                <span>{summary?.passRate ? `${summary.passRate}%` : '–'}</span>
              </div>
              <div>
                <span>Total units failed:</span>
                <span>
                  {summary?.failedCount ? summary.failedCount.toLocaleString('en-US') : '–'}
                </span>
              </div>
            </div>
            <div>
              <div className='fails'>
                <span>Fail reasons</span>
                <div className='value'>
                  {summary.failReasons?.length
                    ? summary.failReasons.map((fail, index) => (
                        <div key={'summary-fail--' + index}>
                          {fail.name}: <span>{fail.value}%</span>
                        </div>
                      ))
                    : '-'}
                </div>
              </div>
            </div>
            <div>
              <div className='general-stat'>
                <span>General</span>
                <div className='value'>
                  <div>
                    Total Inventory:
                    <span>
                      {vehiclesStat?.vehiclesTotal
                        ? vehiclesStat.vehiclesTotal.toLocaleString('en-US')
                        : '–'}
                    </span>
                  </div>
                  <div>
                    Units With Images:
                    <span>
                      {!vehiclesStat?.vehiclesWithImages ? (
                        <> - / - </>
                      ) : (
                        <>
                          {vehiclesStat.vehiclesWithImages.toLocaleString('en-US')}
                          {' / '}
                          {vehiclesStat.imagesPersent.toLocaleString('en-US')}%
                        </>
                      )}
                    </span>
                  </div>
                  <div>
                    Currently Verified:
                    <span>
                      {!vehiclesStat?.verifiedTotol ? (
                        <> - / - </>
                      ) : (
                        <>
                          {vehiclesStat.verifiedTotol.toLocaleString('en-US')}
                          {' / '}
                          {vehiclesStat.verificationsPersent.toLocaleString('en-US')}%
                        </>
                      )}
                    </span>
                  </div>
                  <div>
                    Units Without Images:
                    <span>
                      {vehiclesStat?.vehiclesNoImages
                        ? vehiclesStat?.vehiclesNoImages.toLocaleString('en-Us')
                        : '–'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    Verification Rate of Units With Images:
                    <span>
                      {vehiclesStat?.successPersent
                        ? vehiclesStat?.successPersent.toLocaleString('en-Us') + '%'
                        : '–'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className='general-stat image-stat'>
                <span>Units have images</span>
                <div className='value'>
                  <div>
                    LotFlo Only: Units / Verified:
                    <span>
                      {vehiclesStat?.vehiclesLotfloOnly
                        ? vehiclesStat.vehiclesLotfloOnly.toLocaleString('en-US')
                        : '–'}
                      {' / '}
                      {vehiclesStat?.verifiedLotfloOnly
                        ? vehiclesStat.verifiedLotfloOnly.toLocaleString('en-US')
                        : '–'}
                    </span>
                  </div>
                  <div>
                    HomeNet Only: Units / Verified:
                    <span>
                      {vehiclesStat?.vehiclesHomenetOnly
                        ? vehiclesStat?.vehiclesHomenetOnly.toLocaleString('en-Us')
                        : '–'}
                      {' / '}
                      {vehiclesStat?.verifiedHomenetOnly
                        ? vehiclesStat?.verifiedHomenetOnly.toLocaleString('en-Us')
                        : '–'}
                    </span>
                  </div>
                  <div>
                    Both: Units / Verified:
                    <span>
                      {vehiclesStat?.vehiclesBoth
                        ? vehiclesStat?.vehiclesBoth.toLocaleString('en-Us')
                        : '–'}
                      {' / '}
                      {vehiclesStat?.verifiedBoth
                        ? vehiclesStat?.verifiedBoth.toLocaleString('en-Us')
                        : '–'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </ActivityHeaderInfoCol>
        </ActivityHeader>
      </ContentBoard>
      <ExportButtonStyled onClick={() => performExport('csv')}>
        Export CSV report
      </ExportButtonStyled>
    </>
  );
}
